import axios from "axios";
import { useCallback, useEffect, useState } from "react";

export const api = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api` });

const TOKEN = "dc_access";
const REFRESH = "dc_refresh";

export const tokens = {
  set: (a, r) => {
    localStorage.setItem(TOKEN, a);
    if (r) localStorage.setItem(REFRESH, r);
  },
  access: () => localStorage.getItem(TOKEN),
  clear: () => {
    localStorage.removeItem(TOKEN);
    localStorage.removeItem(REFRESH);
  },
};

api.interceptors.request.use((cfg) => {
  const t = tokens.access();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

let online = true;
const setOnline = (v) => {
  if (v === online) return;
  online = v;
  window.dispatchEvent(new Event(v ? "dc-online" : "dc-offline"));
};

api.interceptors.response.use(
  (r) => {
    setOnline(true);
    return r;
  },
  async (err) => {
    const s = err.response?.status;
    setOnline(!(!err.response || s === 502 || s === 503 || s === 504));
    const cfg = err.config || {};
    const isAuthCall = cfg.url?.startsWith("/auth/");
    if (err.response?.status === 401 && !isAuthCall && !cfg._retry) {
      const refresh = localStorage.getItem(REFRESH);
      if (refresh) {
        try {
          cfg._retry = true;
          const { data } = await api.post("/auth/refresh", { refresh_token: refresh });
          tokens.set(data.access_token);
          return api(cfg);
        } catch (_) {
          /* falls through to logout */
        }
      }
      tokens.clear();
      window.dispatchEvent(new Event("dc-logout"));
    }
    return Promise.reject(err);
  }
);

export function errMsg(e, fallback = "Ocorreu um erro. Tente novamente.") {
  if (!e?.response) return "Sem ligação ao servidor. Verifique a ligação e tente novamente.";
  const { status, data } = e.response;
  if (status >= 500) return `Servidor indisponível (erro ${status}). Tente novamente dentro de instantes.`;
  const detail = data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((d) => d?.msg || JSON.stringify(d)).join(" ");
  return fallback;
}

export function useApi(path, intervalMs) {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const load = useCallback(async () => {
    try {
      const r = await api.get(path);
      setData(r.data);
      setError(null);
    } catch (e) {
      setError(errMsg(e));
    }
  }, [path]);
  useEffect(() => {
    load();
    window.addEventListener("dc-online", load);
    const t = intervalMs ? setInterval(load, intervalMs) : null;
    return () => {
      window.removeEventListener("dc-online", load);
      if (t) clearInterval(t);
    };
  }, [load, intervalMs]);
  return { data, error, reload: load };
}
